/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { get } from 'lodash';
import { isInt, isFloat } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import {
  InputAdornment,
  Box,
  TextField,
  Button,
  Autocomplete,
  Grid,
  IconButton,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { FaFileUpload, FaRegTrashAlt } from 'react-icons/fa';
import axios from '../../services/axios';
import { Container, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';
import NumberFormatKm from '../../utils/NumberFormatKm';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import NumberFormatCustom3 from '../../utils/NumberFormatCustom3';

export default function Despesa() {
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.auth.user.flag_admin);
  const navigate = useNavigate();
  const { id1 } = useParams(); // id viagem
  const { id2 } = useParams(); // id despesa

  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');
  const [id_viagem, setViagem] = useState('');
  const [id_posto, setPosto] = useState('');
  const [id_tipodespesa, setTipoDespesa] = useState('');
  const [anexo, setAnexo] = useState('');
  const [anexo1, setAnexo1] = useState('');
  const [quilometragem, setQuilometragem] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [flagCombustivel, setFlagCombustivel] = useState('');
  const [flagArla, setFlagArla] = useState('');
  const [flagChecked, setFlagChecked] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tableTipoDespesa, setTableTipoDespesa] = useState([]);
  const [tablePosto, setTablePosto] = useState([]);
  const [filteredTipoDespesa, setFilteredTipoDespesa] = useState([]); // Estado para as opções filtradas
  const [preview, setPreview] = useState('');
  const [preview1, setPreview1] = useState('');
  const [anexoChanged, setAnexoChanged] = useState(false);
  const [anexo1Changed, setAnexo1Changed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const textData = 'Despesa';
  const tableDatas = 'despesas';

  const processFile = (file, setAnexoN, setPreviewN, setChanged) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const maxWidth = 800;
        const scale = maxWidth / img.width;
        const newWidth = maxWidth;
        const newHeight = img.height * scale;

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        ctx.canvas.toBlob(
          (blob) => {
            const newFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });

            setAnexoN(newFile);
            setPreviewN(URL.createObjectURL(newFile));
            setChanged(true);
          },
          'image/jpeg',
          0.75
        );
      };
    };
    reader.readAsDataURL(file);
  };

  const handleImageChange = (e, setAnexoN, setPreviewN, setChanged) => {
    const file = e.target.files[0];
    if (file) {
      processFile(file, setAnexoN, setPreviewN, setChanged);
    }
  };

  const handleRemoveAnexo = (setAnexoN, setPreviewN, setChanged) => {
    setPreviewN(null);
    setAnexoN(null);
    setChanged(true);
  };

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/${tableDatas}/${id2}`);
      setDescricao(data.descricao);
      setValor(data.valor);
      setViagem(data.id_viagem);
      setPosto(data.id_posto);
      setTipoDespesa(data.id_tipodespesa);
      setFlagCombustivel(get(data, 'TipoDespesa.flag_combustivel', ''));
      setFlagArla(get(data, 'TipoDespesa.flag_arla', ''));
      setQuilometragem(data.quilometragem);
      setQuantidade(data.quantidade);
      setFlagChecked(data.flag_checked ? 1 : 0);

      // Verificar se anexo não é null ou undefined e se tem mais que 50 bytes
      if (
        data.anexo &&
        typeof data.anexo === 'string' &&
        data.anexo.length > 50
      ) {
        setAnexo(data.anexo);
        setPreview(data.anexo);
      } else {
        setAnexo(null);
        setPreview(null);
      }

      // Verificar se anexo1 não é null ou undefined e se tem mais que 50 bytes
      if (
        data.anexo1 &&
        typeof data.anexo1 === 'string' &&
        data.anexo1.length > 50
      ) {
        setAnexo1(data.anexo1);
        setPreview1(data.anexo1);
      } else {
        setAnexo1(null);
        setPreview1(null);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(-1);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      let response = await axios.get('/tipodespesas');
      setTableTipoDespesa(response.data);
      setFilteredTipoDespesa(response.data); // Inicialmente sem filtro

      response = await axios.get('/postos');
      setTablePosto(response.data);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(-1);
    }
  }

  useEffect(() => {
    getDataDropdown();
    if (!id2) {
      setViagem(id1);
      return;
    }
    getData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    let formErrors = false;

    if (!isInt(String(id_viagem))) {
      toast.error(`ID viagem inválido: ${id_viagem}`);
      formErrors = true;
    }

    if (!isInt(String(id_tipodespesa))) {
      toast.error('ID do tipo de despesa inválido');
      formErrors = true;
    }

    if (!isFloat(String(valor))) {
      toast.error('Valor inválido');
      formErrors = true;
    }
    if (flagCombustivel || flagArla) {
      if (!isFloat(String(quilometragem))) {
        toast.error('Km do Veículo inválido');
        formErrors = true;
      }

      if (!isFloat(String(quantidade))) {
        toast.error('Quantidade inválida');
        formErrors = true;
      }

      if (!isInt(String(id_posto))) {
        toast.error('ID do posto inválido');
        formErrors = true;
      }
    }
    if (formErrors) return;

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('descricao', descricao);
      formData.append('valor', valor);
      formData.append('id_viagem', id_viagem);
      formData.append('id_tipodespesa', id_tipodespesa);
      formData.append('flag_checked', flagChecked ? 1 : 0);
      if (flagCombustivel || flagArla) {
        formData.append('id_posto', id_posto);
        formData.append('quilometragem', quilometragem);
        formData.append('quantidade', quantidade);
      }

      if (anexoChanged) {
        formData.append('anexo', anexo);
      }
      if (anexo1Changed) {
        formData.append('anexo1', anexo1);
      }
      if (id2) {
        await axios.put(`/${tableDatas}/${id2}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        toast.success('Alterado com sucesso!');
      } else {
        await axios.post(`/${tableDatas}/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        toast.success('Cadastrado com sucesso!');
      }
      navigate(-1);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro inesperado:', e);
      }

      if (status === 401) dispatch(actions.loginFailure());
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const handleIconClick = (inputRef) => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleChange = (e) => {
    setValor(e.target.value);
  };

  // Função para filtrar quando o ComboBox for aberto
  const handleOpenAutocomplete = () => {
    // condição para somente o filtro aplicar ao motorista
    if (isAdmin === 3) {
      // Filtrar somente as opções onde flag_motorista = true
      const filtered = tableTipoDespesa.filter(
        (item) => item.flag_fixovariavel === 1
      );
      setFilteredTipoDespesa(filtered);
    } else {
      // Se não for motorista, exibir todas as opções
      setFilteredTipoDespesa(tableTipoDespesa);
    }
  };

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Title>{id2 ? `Alterar ${textData}` : `Nova ${textData}`}</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isAdmin > 2}
                  checked={flagChecked === 1}
                  onChange={(e) => setFlagChecked(e.target.checked ? 1 : 0)}
                  size="small"
                />
              }
              label="Conferido pelo Operacional"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              disabled={flagChecked}
              id={id_tipodespesa}
              value={
                filteredTipoDespesa.find(
                  (option) => option.id === id_tipodespesa
                ) || null
              }
              options={filteredTipoDespesa}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setTipoDespesa(newValue ? newValue.id : '');
                setFlagCombustivel(newValue ? newValue.flag_combustivel : '');
                setFlagArla(newValue ? newValue.flag_arla : '');
              }}
              onOpen={handleOpenAutocomplete} // Filtra as opções ao abrir o ComboBox
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Tipo Despesa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              disabled={flagChecked}
              value={valor}
              label="Valor da Despesa"
              size="small"
              onChange={handleChange}
              InputProps={{
                name: 'valor',
                inputComponent: NumberFormatCustom,
                onChange: handleChange,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          {(flagCombustivel || flagArla) && (
            <>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled={flagChecked}
                  required
                  value={quilometragem}
                  label="Km do Veículo"
                  size="small"
                  onChange={(e) => setQuilometragem(e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatKm,
                    startAdornment: (
                      <InputAdornment position="start">Km</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled={flagChecked}
                  value={quantidade}
                  label="Quantidade"
                  size="small"
                  onChange={(e) => setQuantidade(e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatCustom3,
                    startAdornment: (
                      <InputAdornment position="start">L</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  disabled={flagChecked}
                  id={id_posto}
                  value={
                    tablePosto.find((option) => option.id === id_posto) || null
                  }
                  options={tablePosto}
                  getOptionLabel={(option) => option.nome}
                  onChange={(event, newValue) => {
                    setPosto(newValue ? newValue.id : '');
                  }}
                  renderInput={(params) => (
                    <TextField
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      required
                      label="Posto Conveniado"
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={12}>
            <TextField
              disabled={flagChecked}
              value={descricao}
              label="Observação"
              size="small"
              onChange={(e) => setDescricao(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'left' }}>
            <input
              ref={fileInputRef1}
              accept="image/*"
              type="file"
              onChange={(e) =>
                handleImageChange(e, setAnexo, setPreview, setAnexoChanged)
              }
              style={{ display: 'none' }}
            />
            <IconButton
              disabled={flagChecked}
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => handleIconClick(fileInputRef1)}
            >
              <FaFileUpload style={{ fontSize: 20 }} />
              Carregar Nota Fiscal
            </IconButton>
          </Grid>
          {preview && (
            <Box
              sx={{
                margin: '10px 0',
                textAlign: 'center',
              }}
            >
              <img
                src={preview}
                alt="Anexo 1"
                style={{ maxWidth: '100%', maxHeight: '200px' }}
              />
              <IconButton
                disabled={flagChecked}
                onClick={() =>
                  handleRemoveAnexo(setAnexo, setPreview, setAnexoChanged)
                }
                color="error"
              >
                <FaRegTrashAlt />
              </IconButton>
            </Box>
          )}
          <Grid item xs={12} style={{ textAlign: 'left' }}>
            <input
              ref={fileInputRef2}
              accept="image/*"
              type="file"
              onChange={(e) =>
                handleImageChange(e, setAnexo1, setPreview1, setAnexo1Changed)
              }
              style={{ display: 'none' }}
            />
            <IconButton
              disabled={flagChecked}
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => handleIconClick(fileInputRef2)}
            >
              <FaFileUpload style={{ fontSize: 20 }} />
              Carregar Hodômetro
            </IconButton>
          </Grid>
          {preview1 && (
            <Box
              sx={{
                margin: '10px 0',
                textAlign: 'center',
              }}
            >
              <img
                src={preview1}
                alt="Anexo 2"
                style={{ maxWidth: '100%', maxHeight: '200px' }}
              />
              <IconButton
                disabled={flagChecked}
                onClick={() =>
                  handleRemoveAnexo(setAnexo1, setPreview1, setAnexo1Changed)
                }
                color="error"
              >
                <FaRegTrashAlt />
              </IconButton>
            </Box>
          )}
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id2 ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button type="button" onClick={() => navigate(-1)}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
